export const isLeaderAction = (data) => {
    return {
        type: "IS_LEADER",
        payload : data,
    };
};
